








































import {Vue, Component, Prop} from 'vue-property-decorator'
import TooltipInfoButton from '@/components/TooltipInfoButton.vue'

@Component({
  components: {TooltipInfoButton},
})
export default class BridgeTokenAccountBalance extends Vue {
  @Prop({type: String, required: true}) tokenAccountBalance!: string
  /** The balance could not be read — show N/A instead of a misleading zero. */
  @Prop({type: Boolean, default: false}) isUnavailable!: boolean
  @Prop({type: String, default: ''}) unavailableMessage!: string

  get amountFormatted() {
    return `${Number(this.tokenAccountBalance).toLocaleString('en-US', {
      maximumFractionDigits: 10,
      minimumFractionDigits: 0,
    })}`
  }
}
